import gql from 'graphql-tag';

export const WORKSPACE_MEMBER_FRAGMENT = gql`
  fragment WorkspaceMember on CustomerMember {
    id
    email
    name
    role
  }
`;

export const WORKSPACE_FRAGMENT = gql`
  fragment Workspace on Workspace {
    id
    name
    creator {
      id
      name
      email
    }
    workspaceMembers {
      ...WorkspaceMember
    }
    workspaceMembersCount
    accessType
  }
  ${WORKSPACE_MEMBER_FRAGMENT}
`;
